import * as React from "react";
import { MapsProps, MapsInjectedProps } from "./typings";
import { Maps } from "./Maps";
import { Maps as DynamicMaps } from "./views/DynamicMaps";
import { withStores } from "stores";

export const MapsViews = withStores(
  "analytics",
  "hotels",
  "staticMap",
  "context",
  "poi",
  "routeStore"
)((props: MapsProps & MapsInjectedProps) => {
  if (props.flexComponent.model.view === "dynamic") {
    return <DynamicMaps {...props} />;
  }

  return <Maps {...props} />;
});

export default MapsViews;
